import { MrbBaseListViewStore } from "mrb/core";
import { MrbGridViewStore } from "mrb/components/grid";
import { PodcastAnalyticsService } from "common/services";
import { computed, makeObservable } from "mobx";

class PodcastListenersListViewStore extends MrbBaseListViewStore {
    @computed get isInitalized() {
        return this.gridStore.dataInitialized;
    }

    constructor(rootStore, podcastListenersListViewStore) {
        super(rootStore, {});
        makeObservable(this);
        this.podcastListenersListViewStore = podcastListenersListViewStore;
        this.routeStore = this.podcastListenersListViewStore.routeStore;
        this.service = rootStore.createApplicationService(PodcastAnalyticsService);

        this.setGridStore(
            new MrbGridViewStore(this.rootStore, this.queryUtility, {
                generateKey: (item) => item.id,
                mapper: (item, i) => {
                    return {
                        ...item,
                        coverImageUrl: this.createCoverImageUrl(item),
                        position: i + 1,
                    };
                },
            })
        );
        this.createCoverImageUrl = this.createCoverImageUrl.bind(this);
    }

    async onInit() {
        this.gridStore.suspend();
        const response = await this.service.getPodcastListenersStats();
        this.gridStore.setData(response.data);
        this.gridStore.resume();
    }

    createCoverImageUrl(item) {
        if (item && item.coverImageId) {
            return this.rootStore.coverImageFactory.createPodcastCoverImageUrl(item.coverImageId, 150, 150);
        }
        return null;
    }
}

export default PodcastListenersListViewStore;
